export default __webpack_public_path__ + "static/media/bar-chart.342a8362.svg";